import { Component, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderService } from './../header/header.service';
import { HttpResponse } from '@angular/common/http';
import { UtilityService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { CMSResolver } from 'lib/ng2-sapmp/src/providers/cms.resolver';
import { AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers/adobe-analytics.service';
import { AuthenticationService } from 'lib/ng2-sapmp/src/providers/authentication.service';
import { SAPMPProfileModel } from 'lib/ng2-sapmp/src/models/userprofile/loginsources/sapmp.model';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { HomeComponent, HOME_DATA } from '../home';
import { MDMDetails } from './../../models/product';
import { ADDP_PERMISSION_MAPPING, LOGIN_ERROR } from 'config';
import { Subscription } from 'rxjs';

declare var PREMIER_LOGIN_URL: any;
declare var MYATT_LOGIN_URL: any;
declare var FIRSTNET_LOCAL_CONTROL_URL: any;
declare var ENV_PORTAL;
declare var logoutHeaderChange;
declare var logoutCurrentUser: Function;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  triggerUrl: any;
  dashboard: any;
  trial: any;
  pageContent: any;
  abc: any;
  fnabc: any;
  funtion: any;
  firstNetLocalControl: any;
  pageContentkey: any;
  pageLoadChangesDone: boolean = false;
  commonLoginContainer: boolean = false;
  public user;
  hideNotification;
  public redirectFlag: boolean = false;
  toggleAlertMenu;
  public mdmDetails: MDMDetails;
  public isLoggingIn = true;
  public tileName: boolean = true;
  public pageTitle: any;
  public landingPageRoute: string;
  public homePage: any;

  public display: boolean = false;
  public openDropMenu: boolean = true;
  public closeDropMenu: boolean = false;
  public show5gOption: boolean = true;
  public headerHideEvent: Subscription;
  isNotSelectStubId: boolean = true;
  public enrollStatusSubscription: Subscription;
  showRegisterIcon: boolean = false;
  isAdminLoggedIn: boolean = false;
  lastLogin: any = "";
  public getLastLogin: Subscription;
  lastLoginTime: string;
  constructor(private router: Router,
    private utilityService: UtilityService,
    private headerService: HeaderService, private pageloaderService: PageLoaderService,
    private authenticationService: AuthenticationService, private el: ElementRef, private adobeAnalyticsService: AdobeAnalyticsService,
  ) {


    // this.pageContentkey = (ENV_PORTAL === 'sapmp')? "headerabc" : "headerfnabc";
    this.headerService.pageContent(ENV_PORTAL).subscribe((res: HttpResponse<any>) => {
      this.pageContent = res[ENV_PORTAL].header;
      sessionStorage.setItem('loginDropdownPopupSwitch', this.pageContent.loginDropdownPopup);
      console.log("PageContent----", this.pageContent);
      console.log("PageContent.sideMenu---", this.pageContent.sideMenu.list);


    });

    this.firstNetLocalControl = ENV_PORTAL === 'fnabc' ? FIRSTNET_LOCAL_CONTROL_URL : '';
    this.hideNotification = HeaderService.hideNotification;
    this.toggleAlertMenu = headerService.toggleAlertMenu;
    this.homePage = HOME_DATA;
    this.mdmDetails = new MDMDetails();

    if (ENV_PORTAL === "dmpadmin") {
      this.tileName = false;
      this.isAdminLoggedIn = true;
    }
    AuthenticationService.User$.subscribe(u => {
      if (u === 'loading') {
        // this.isLoggingIn = true; 
        this.user = undefined;
      } else {
        this.isLoggingIn = false;
        this.user = u;
        // console.log("u===============>",this.user);

        // Fixes added for home page spinner issue
        if (this.user != undefined) {
          if (this.user.firstName && window.location.pathname.includes('home')) {
            // console.log("u==============================>",this.user);
            // let firstName = document.getElementsByClassName('first-name')[0].innerHTML;
            // console.log("firstName===============>",firstName);
            // console.log("firstName===============>", this.user.firstName);
            document.getElementsByClassName("first-name")[0].innerHTML = this.user.firstName + ' ' + this.user.lastName;
            // document.addEventListener("DOMContentLoaded", function (event) {
            //   document.getElementsByClassName("first-name")[0].innerHTML = this.user.firstName ;
            // });
          }
        }

      }
    });


    // this.headerService.userLogin();
    // this.headerService.setlogoutHeaderChanges(false);

    // this.headerService.getlogoutHeaderChanges().subscribe(data => {
    //   if (data) {
    //     HeaderService.logoutHeaderChange();
    //     this.headerService.setlogoutHeaderChanges(false);
    //   }
    // });

    // this.headerService.getHideMenu().subscribe(data => {
    //   if (data) {
    //     this.hideMenu();
    //     // this.headerService.checkCart();
    //     this.headerService.setHideMenu(false);
    //   }
    // });
    // if (this.authenticationService.getUser() || this.authenticationService.getPermissions()) {
    //   this.headerService.userLogin();
    //   this.headerService.setlogoutHeaderChanges(false);
    // } else {
    //   this.headerService.setlogoutHeaderChanges(true);
    //   this.headerService.logoutUser();
    // }

    // if(location.href.indexOf("selectstubid") == -1)  {
    //   // this.isSelectStubId = true;
    //   this.isNotSelectStubId = true;
    // }  else if (location.href.indexOf("selectstubid") != -1) {
    //   // this.isSelectStubId = false;
    //   this.isNotSelectStubId = false; 
    //  }

    // setTimeout(() => {
    //   //check if login is failed
    //   let loginError = sessionStorage.getItem('loginFailedError');
    //   //get last login history
    //   if(loginError == null || loginError == undefined) {
    //     this.authenticationService.getLastLoginHistory().subscribe(
    //       (loginRes) => {
    //         console.log("last login info: ", loginRes);
    //         sessionStorage.setItem('lastLoginHistory', JSON.stringify(loginRes));
    //         // this.showLastLogin();
    //       },
    //       (error) => {
    //         console.error('Error fetching last login history:', error);
    //       }
    //     ); 
    //   }else{
    //     sessionStorage.removeItem('lastLoginHistory');
    //     sessionStorage.removeItem('loginFailedError');
    //     // this.showLastLogin();
    //   }
      
    // }, 2000);
  }

  enrollRouteActive() {
    if (this.router.url == '/productselection' || this.router.url == '/welcome' || this.router.url == '/signupsetup/enrollmentoptions' || this.router.url == '/signupsetup/review' || this.router.url == '/signupsetup/confirm') {
      return true;
    } else {
      let navlist = document.querySelectorAll('.has-subnav');
      navlist[1].classList.remove('active');
      if (this.learnRouteActive()) {
        navlist[3].classList.add('active')
      }
      return false;
    }
  }

  learnRouteActive() {
    //Changes as a part of US-1367 to force route active to return false for learn menu item
    // if (this.router.url == '/learn/products' || this.router.url == '/learn/applebusinessmanager' || this.router.url == '/learn/androidzerotouch' || this.router.url == '/learn/samsungknoxmobile' || this.router.url == '/learn/5g') {
    //   return true;
    // } else {
    //   return false;
    // }
    return false;
  }


  homeRouteActive(parm) {
    let navlist = document.querySelectorAll('.has-subnav');
    if (this.router.url == parm) {
      navlist[7].classList.remove('active');
      return this.router.url;
    }
  }

  ngOnInit() {
    if (ENV_PORTAL === "dmpadmin") {
      this.tileName = false;
    }
    if(ENV_PORTAL === "fnabc" || ENV_PORTAL === "myatt") {
      this.show5gOption = false;
    }

    // window.addEventListener('load', () => {
    this.lastLoginTime = sessionStorage.getItem('lastLoginTime');
    // });
    
    this.landingPageRoute = this.authenticationService.getLandingPageRoute();
    document.body.addEventListener('keyup', function (event) {
      var container = document.getElementById('hamNav');
      if (event.keyCode == 9) {
        if (!container.contains(document.activeElement)) {
          document.getElementById('hamNav').classList.remove('active');
          document.body.classList.remove('m-open');
          HeaderComponent.closeHamburgerMenu();
        }
      }
      var container2 = document.getElementById('userProfileInfo');
      if (event.keyCode == 9) {
        if (!container2.contains(document.activeElement)) {
          document.getElementById('userProfileInfo').classList.remove('active');
          document.body.classList.remove('d-open');
        }
      }
    });
    document.body.addEventListener('click', (event: MouseEvent) => {
      //For hiding menu on outside click.
      var container = document.getElementById('hamNav');
      var node = <Node>event.target;
      var element = <HTMLElement>event.target;
      if (!container.contains(node)) {
        var commonLogin = document.getElementById('common-login-container');
        document.getElementById('hamNav').classList.remove('active');
        if (ENV_PORTAL === "dmpadmin") (
          document.getElementById('main-menu').classList.remove('sub-active'));
        document.body.classList.remove('m-open');
        HeaderComponent.closeHamburgerMenu();
      }
      //For hiding notification on outside click
      var container2 = document.getElementById('userProfileInfo');
      var userprofile = document.getElementsByClassName('user-profile')[0];
      var profile = document.getElementsByClassName('profile')[0];
      if (container2 && !container2.contains(node) && document.contains(node)) {
        userprofile.classList.remove('show');
        HeaderService.hideNotification();
      }

      var container3 = document.getElementById('notification-box');
      if (element.className != 'log-out-text sm-hide' && element.className != 'loginBtn' && element.className != 'icon-people-oneperson') {
        document.getElementById('loginModal-box').classList.remove('active');
      }
    });

    this.enrollStatusSubscription = this.authenticationService.getEnrollStatus().subscribe(status => {
      console.log("Enroll Status: " + status);
      this.showRegisterIcon = status;
      // Perform any additional actions needed when enrollStatus changes
    });
    
  }

  hideMenu() {
    document.getElementById('hamNav').classList.remove('active');
    document.body.classList.remove('m-open');
    HeaderComponent.closeHamburgerMenu();
  }

  openCloseSubMenu(id) {
    if (id === "show") {
      this.display = true;
      this.openDropMenu = false;
      this.closeDropMenu = true;
    } else if (id === "hide") {
      this.display = false;
      this.openDropMenu = true;
      this.closeDropMenu = false;
    }
  }
  static closeHamburgerMenu() {
    var expand = document.querySelector('.menu-btn');
    expand.setAttribute("aria-label", "Open the menu.");
  }
  toggleMenu(elem) {
    console.log("toggle menu called...");
    elem.parentElement.classList.toggle('active');
    document.body.classList.toggle('m-open');
    var expand = document.querySelector('.menu-btn');
    expand.setAttribute("aria-label", "Close the menu.");
  }

  setRKey(parameter) {
    this.triggerUrl = parameter === 'myatt' ? MYATT_LOGIN_URL : PREMIER_LOGIN_URL;
    window.location.href = this.triggerUrl;
  }

  setCallingPage(callingPageUrl) {
    sessionStorage.setItem('callingPageName', callingPageUrl);
  }

  checkSlider(buttonLink, title) {
    let navlist = document.querySelectorAll('.has-subnav');
    navlist[0].classList.remove('active');
    navlist[1].classList.remove('active');
    navlist[7].classList.remove('active');
    document.getElementById("menu-toggle").click();
    this.display = false;
    this.openDropMenu = true;
    this.closeDropMenu = false;
    if ((buttonLink === "/learn/androidzerotouch") || (buttonLink === "/learn/applebusinessmanager") || (buttonLink === "/learn/samsungknoxmobile")) {
      navlist[3].classList.add('active');
    }
    if (buttonLink.startsWith('http')) {
      this.adobeAnalyticsService.createClickProperties('Learn more about ' + title, 'Body', buttonLink);
      window.open(buttonLink);
    }
    else {
      this.adobeAnalyticsService.createClickProperties('Learn more about ' + title, 'Body', '/businessconsole' + buttonLink);
      return this.router.navigate([buttonLink]);
    }
  }


  commonFunction(funcName, parameter) {
    if (location.href.indexOf('selectstubid') != -1 && (parameter == "/support" || parameter == "/faq" || parameter =="/learn")) {
      alert('Please select a StubID to proceed.');
    } else {
    this.hideMenu();
    this.display = false;
    this.openDropMenu = true;
    this.closeDropMenu = false;
    document.getElementById("menu-toggle").click();

    if (ENV_PORTAL != "dmpadmin") {
      let navlist = document.querySelectorAll('.has-subnav');
      navlist[7].classList.remove('active');
      if (parameter === "/learn") {
        navlist[1].classList.add('active');
        navlist[3].classList.remove('active');
        this.navigateDeviceAndShop();
      }
      else if (parameter === "/learn/products") {
        navlist[1].classList.remove('active');
        navlist[3].classList.add('active');
      }
      else {
        navlist[1].classList.remove('active');
        navlist[3].classList.remove('active');
        navlist[7].classList.remove('active');
      }
    }

    if (funcName == "setRKey") {
      this.setRKey(parameter);
    }
    else if (funcName == "setCallingPage") {
      this.setCallingPage(parameter);
    }
    else if (funcName == "localControl") {
      window.open(FIRSTNET_LOCAL_CONTROL_URL);
    }
    else if (funcName == 'action') {
      window['store'].dispatch({ type: parameter });
      this.headerService.setHideMenu(true);
    }
  }
}

  //TODO this is where you set the domain
  loginDirect(portal) {
    this.commonLoginContainer = !this.commonLoginContainer;
    this.authenticationService.loginDirect(portal);
  }

  commonLoginDropdown() {
    if (location.href.indexOf("selectstubid") != -1) {
      alert("Please select a StubID to proceed.");
    }
    else { 
      document.getElementById('loginModal-box').classList.toggle('active');
    }
  }

  toggleSubMenu() {
    document.getElementById('main-menu').classList.toggle('sub-active');
    var expand = document.querySelector('#sub-menu');
    var attribute = expand.getAttribute('aria-expanded');
    if (attribute.includes('true'))
      expand.setAttribute("aria-expanded", "false");
    else
      expand.setAttribute("aria-expanded", "true");
  }

  navigateDeviceAndShop() {
    let navlist = document.querySelectorAll('.has-subnav');
    navlist[0].classList.remove('active');
    navlist[1].classList.add('active');
    this.pageloaderService.setPageLoaderStatus(false);
    let processingFans = JSON.parse(sessionStorage.getItem('processingFanList'));
    let processingFansCount = JSON.parse(sessionStorage.getItem('processingFanList')) ? processingFans.length : 0;
    if (sessionStorage.getItem('sapmp_jwtToken') === null) {
      sessionStorage.setItem('eligibilityCheck', 'true');
      // this.landingPageRoute = this.homePage?.links[0]?.rlink;
      this.landingPageRoute = this.pageContent.sideMenu?.list[1]?.routerLink;
      console.log(this.homePage?.links[0]?.rlink);
      this.adobeAnalyticsService.createClickProperties(this.homePage?.links[0]?.linkName, 'Body', '/businessconsole' + this.landingPageRoute);
      navlist[1].classList.add('active');
      return this.router.navigate([this.landingPageRoute]);
    }
    this.user = this.authenticationService.getUser();
    if (this.user.addpAuthority !== 'NONE') {
      this.authenticationService.getFanSignedUpStatus()
        .subscribe(resp => {
          sessionStorage.setItem("accountSummaryData", JSON.stringify(resp));
          sessionStorage.setItem('initialSignupStatus', resp.initialSignupStatus);
          sessionStorage.setItem('noOfDevice', resp.noOfDevices);
          if (resp.fansSummary?.length > 0) {
            let signupFanSum = resp.fansSummary;
            let signupFanList = [];
            let signupActiveFanList = [];
            let processingFanList = [];
            let inProgressFan = [];
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "AWAITING_SIGNUP") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  signupFanList.push(signupFanSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('signupFanList', JSON.stringify(signupFanList));

            //get active fans list
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "ACTIVE") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  signupActiveFanList.push(signupFanSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('signupActiveFanList', JSON.stringify(signupActiveFanList));
            //for 'processing' fans
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "PROCESSING") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  //processingFanList.push(signupFanSum[i].fans[j]);
                  inProgressFan.push(signupFanSum[i].fans[j]);
                  //getting fan info of 'processing' fan to store in session storage
                  for (let k = 0; k < resp.fanInfoList.length; k++) {
                    if (signupFanSum[i].fans[j] === resp.fanInfoList[k].fan) {
                      processingFanList.push(resp.fanInfoList[k]);
                    }
                  }
                }
              }
            }
            sessionStorage.setItem('inProgressFan', JSON.stringify(inProgressFan));
            sessionStorage.setItem('processingFanList', JSON.stringify(processingFanList));
          }
          if (!resp.efotaFansSummary) {
            sessionStorage.setItem('efotaEnrolledFanList', '[]');
          }
          else {
            let efotaFansSum = resp.efotaFansSummary;
            let efotaEnrolledFanList = [];
            for (let i = 0; i < efotaFansSum.length; i++) {
              if (efotaFansSum[i].status == "ACTIVE") {
                for (let j = 0; j < efotaFansSum[i].count; j++) {
                  efotaEnrolledFanList.push(efotaFansSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('efotaEnrolledFanList', JSON.stringify(efotaEnrolledFanList));
          }
          if (!resp.efotaNotEnrolledFanList) {
            sessionStorage.setItem('efotaNotEnrolledFanList', '[]');
            sessionStorage.setItem('efotaEnrollmentInfo', '[]');
          }
          else {
            sessionStorage.setItem('efotaEnrollmentInfo', JSON.stringify(resp.efotaEnrollmentInfo));
            sessionStorage.setItem('efotaNotEnrolledFanList', JSON.stringify(resp.efotaNotEnrolledFanList));
          }

          if (resp.allFansInEligible === true) {
            this.user.fanSignedUpStatus = 'NotEligible';
          } else {
            if (this.user) {
              this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
            }
            if (resp.productCode !== null && resp.productCode !== undefined) {
              this.mdmDetails.productCode = resp.productCode;
              this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
              if (this.mdmDetails.productCode === 'ADDPMDM') {
                this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
                let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                productDetails.emmProductCode = 'ADDPMDM';
                productDetails.selectedAccID = resp.ibmEmmAccountId;
                productDetails.signupEmmStatus = 'revised';
                sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
              } else {
                if (resp.googleEmmAccountId !== null && resp.googleEmmAccountId !== undefined) {
                  this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
                }
                if (resp.samsungEmmAccountId !== null && resp.samsungEmmAccountId !== undefined) {
                  this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
                }
                if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
                  sessionStorage.setItem('fanInfoList', JSON.stringify(resp.fanInfoList));
                }
              }
              sessionStorage.setItem('mdmDetails', JSON.stringify(this.mdmDetails));
            }
          }
          this.authenticationService.setUser(this.user);

          let checkMore = true;
          let directWelcome = false;
          if (resp.fansSummary) {
            for (let k = 0; k < resp.fansSummary.length; k++) {
              if (resp.fansSummary[k].status === "AWAITING_SIGNUP" && resp.fansSummary[k].count > 0) {
                this.redirectFlag = true;
                checkMore = false;
                if (resp.fansSummary[k].count === resp.noOfFans) {
                  directWelcome = true;
                }
              }
            }
          }

          if (resp.fanInfoList) {
            let fanArr = resp.fanInfoList.map((x) => x.fan);
            let fanArrRefine = [];
            if (fanArr && fanArr.length > 0) {
              fanArrRefine = fanArr.filter(
                (x, index) => fanArr.indexOf(x) === index
              );
            }

            let activeFanArr = resp.fanInfoList.filter((x) => x.accountStatus === "ACTIVE" || x.accountStatus === "SIGNUP_INPROGRESS");
            if (activeFanArr.length === 0) {
              directWelcome = true;
            }

            if (activeFanArr.length < fanArrRefine.length * 3) {
              this.redirectFlag = true;
            }
          }

          if (directWelcome === true) {
            this.router.navigate(['/welcome']);
            navlist[1].classList.add('active');
            this.pageloaderService.setPageLoaderStatus(true);

          } else if (((this.homePage.links[0].rlink === '/learn') && (processingFansCount >= 1)) || this.redirectFlag) {
            this.router.navigate(['/productselection']);
            navlist[1].classList.add('active');
            this.pageloaderService.setPageLoaderStatus(true);
          } else {
            this.pageloaderService.setPageLoaderStatus(true);
            return this.navigationRedirect(this.homePage.links[0].linkName);
          }
        }, () => {
          this.user.fanSignedUpStatus = 'Error';
          this.authenticationService.setUser(this.user);
          return this.navigationRedirect(this.homePage.links[0].linkName);
        });
    } else {
      return this.navigationRedirect(this.homePage.links[0].linkName);
    }
  }

  navigationRedirect(inputLinkName) {
    const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
    const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];

    if (redirectInfo && this.mdmDetails.productCode === 'ADDPMDM' && redirectInfo.logonurl === 'productselection') {
      redirectInfo.logonurl = 'signup';
      this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
    } else if (redirectInfo) {
      this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
    }
    this.adobeAnalyticsService.createClickProperties(inputLinkName, 'Body', '/businessconsole' + this.landingPageRoute);
    this.landingPageRoute = this.authenticationService.getLandingPageRoute();
    this.router.navigate([this.landingPageRoute]);
  }


  getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'AWAITING_SIGNUP'; }).length;
      const abmfePendingSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'SIGNUP_INPROGRESS' }).length;
      if (abmfePendingSignedUpFansCount > 0) {
        fanSignedUpStatus = 'PROCESSING';
      }
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }

  navigateToHome(){
    if(location.href.indexOf("selectstubid") != -1){
      // logoutCurrentUser(false);
      alert("Please select a StubID to proceed.");
    }else{
      this.router.navigate(['home']);
    }
  }

  loginFnDirect(){
    this.authenticationService.loginDirect('fnabc');
  }

  // showLastLogin(){
  //   let lastLogin = sessionStorage.getItem('lastLoginHistory') ? JSON.parse(sessionStorage.getItem('lastLoginHistory')) : '';
  //   if(lastLogin.lastLoggedInTime != null){
  //     console.log("Last LOgin: ", lastLogin);
  //     let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //     console.log("localTimeZone: ", localTimeZone);
  //     const now = new Date(lastLogin.lastLoggedInTime + " UTC");
  //     const formattedDate = now.toLocaleString('en-US', {
  //         year: 'numeric',
  //         month: 'long',
  //         day: 'numeric',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //         second: '2-digit',
  //         hour12: true,
  //         timeZone: localTimeZone
  //     });
  //     console.log("formattedDate: ", formattedDate);//check Invalid Date
  //     document.getElementsByClassName("last-login-info")[0].innerHTML = formattedDate != "Invalid Date" ? "Last Login: "+ formattedDate : "";
  //     document.getElementsByClassName("last-login-info")[1].innerHTML = formattedDate != "Invalid Date" ? "Last Login: "+ formattedDate : "";
  //   }
  // }

  logoutUser(isConfirm){
      this.headerService.logoutCurrentUser(isConfirm);
  }
}

